import { useAuthorizedMutation } from "@/api";
import { params } from "@/params";
import { toast } from "sonner";

export const useEmbedMemory = () => {
  const mutation = useAuthorizedMutation({
    url: `${params.AI_URL}/api/simulate-reply/embed`,
    method: "POST",
  });

  const embedMemory = async (data: any) => {
    try {
      await mutation.mutateAsync(data);
      toast("Successfully saved memory");
    } catch (error) {
      toast.error("Failed to save memory");
    }
  };

  return {
    ...mutation,
    mutate: embedMemory,
  };
};
